export default __webpack_public_path__ + "static/media/referal-whatsapp.7ef6f4b9.svg";